var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2083 8.95833H11.0417V4.79167C11.0417 4.5154 10.9319 4.25045 10.7366 4.0551C10.5412 3.85975 10.2763 3.75 10 3.75C9.72373 3.75 9.45878 3.85975 9.26343 4.0551C9.06808 4.25045 8.95833 4.5154 8.95833 4.79167V8.95833H4.79167C4.5154 8.95833 4.25045 9.06808 4.0551 9.26343C3.85975 9.45878 3.75 9.72373 3.75 10C3.75 10.2763 3.85975 10.5412 4.0551 10.7366C4.25045 10.9319 4.5154 11.0417 4.79167 11.0417H8.95833V15.2083C8.95833 15.4846 9.06808 15.7496 9.26343 15.9449C9.45878 16.1403 9.72373 16.25 10 16.25C10.2763 16.25 10.5412 16.1403 10.7366 15.9449C10.9319 15.7496 11.0417 15.4846 11.0417 15.2083V11.0417H15.2083C15.4846 11.0417 15.7496 10.9319 15.9449 10.7366C16.1403 10.5412 16.25 10.2763 16.25 10C16.25 9.72373 16.1403 9.45878 15.9449 9.26343C15.7496 9.06808 15.4846 8.95833 15.2083 8.95833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.52c0841df92b7a29f68fd38394945b6a.svg";
export { ForwardRef as ReactComponent };